export const tabelaPrecoClienteFilterConfig = [
  {
    id: 'Id',
    type: 'number',
    label: 'Id',
    placeholder: 'Id da associacao'
  },
  {
    id: 'Nome',
    type: 'text',
    label: 'Nome',
    placeholder: 'Digite o nome'
  },
  {
    id: 'CNPJCliente',
    type: 'text',
    label: 'CNPJ',
    placeholder: 'Digite o CNPJ'
  },
  {
    id: 'TipoOperacao',
    type: 'text',
    label: 'Tipo Operacao',
    placeholder: 'Digite o tipo de operacao'
  },
  {
    id: 'DataCriacaoInicio',
    type: 'date',
    label: 'Data Criacao (Inicio)'
  },
  {
    id: 'DataCriacaoFim',
    type: 'date',
    label: 'Data Criacao (Fim)'
  },
  {
    id: 'DataAtualizacaoInicio',
    type: 'date',
    label: 'Data Atualizacao (Inicio)'
  },
  {
    id: 'DataAtualizacaoFim',
    type: 'date',
    label: 'Data Atualizacao (Fim)'
  }
];
